import { compileToFunction, registerMessageCompiler } from '@intlify/core-base';
import { createI18n } from 'vue-i18n';

let messages = {};
if (window.hasOwnProperty('kgr')) {
    messages = kgr.i18n._messages;
}

const numberFormats = {
    de: {
        currency: {
            style: 'currency',
            currency: 'EUR',
        },
    },
};

const fallbackMessages = new Map();

/**
 * Compile a message, degrading to its raw text when it is not valid vue-i18n syntax.
 */
function compileMessageOrFallback(message, context) {
    if (typeof message !== 'string') {
        return compileToFunction(message, context);
    }

    const known = fallbackMessages.get(message);
    if (known) {
        return known;
    }

    let compileError = null;
    try {
        // The stock onError throws in a production build and only logs in a dev build, so record the
        // error either way and let it through - a dev build still gets vue-i18n's own code frame.
        const compiled = compileToFunction(message, {
            ...context,
            onError: (error) => {
                compileError = compileError || error;
                context.onError(error);
            },
        });

        if (!compileError) {
            return compiled;
        }
    } catch (error) {
        if (!(error instanceof SyntaxError)) {
            throw error;
        }
        compileError = error;
    }

    console.error(`i18n: "${context.key}" is not a valid message template (${compileError.message})`);

    const fallback = () => message;
    fallbackMessages.set(message, fallback);

    return fallback;
}

registerMessageCompiler(compileMessageOrFallback);

const i18nInstance = createI18n({
    locale: 'kgr',
    fallbackLocale: 'kgr',
    // Keys are the German source text, so a missing/uncached key is still a valid message
    // template - compile and interpolate it instead of returning it verbatim (e.g. "{count}").
    // Legacy mode only honours the `formatFallbackMessages` spelling; `fallbackFormat` is ignored.
    formatFallbackMessages: true,
    messages: {
        kgr: messages,
    },
    numberFormats,
});

export const plugin = {
    install(app) {
        app.use(i18nInstance);
    },
};

export const i18n = i18nInstance.global;
